import React from 'react'
import { FaRegFolderOpen } from "react-icons/fa6"
import FriendsRow from './FriendsRow'
import Empty from '../../components/empty/Empty'

const FriendsList = ({friends}) => {

      if(friends.code){
            return (
                  <div className="friends_list">
                        <Empty text={`Friends Not Found`} icon={<FaRegFolderOpen />} />
                  </div>
            )
      }

      return (
            <div className="friends_list">
                  {
                        friends.map((friend, index) => (
                              <FriendsRow friend={friend} key={index} />
                        ))
                  }
            </div>
      )
}

export default FriendsList
